import { loadModules } from 'esri-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import BSLAExternalLinkComponent from '../../helpers/BSLAExternalLinkComponent';

const BSLALandUseWetlandsWMDLayer = async () => {
    type layerModules = [typeof import('esri/layers/FeatureLayer')];

    const [FeatureLayer] = await (loadModules(['esri/layers/FeatureLayer']) as Promise<layerModules>);

    return new FeatureLayer({
        title: 'Land Use - Wetlands (WMD)',
        url: 'https://ca.dep.state.fl.us/arcgis/rest/services/OpenData/STATEWIDE_LU_2004_2013/MapServer/3',
        visible: false,
        definitionExpression: "LEVEL2_LANDUSE_DESCRIPTION LIKE '%Wetland%'",
        opacity: 0.5,
        minScale: 150000,
        popupTemplate: {
            outFields: ['*'],
            title: 'Land Use - Wetlands ({WATER_MANAGEMENT_DISTRICT}WMD)',
            content: (feature: __esri.Feature) => {
                const atts = feature.graphic.attributes;
                const node = document.createElement('div');

                let districtName: string | undefined;
                let link: string | undefined;

                switch (atts.WATER_MANAGEMENT_DISTRICT) {
                    case 'SF':
                        districtName = 'South Florida Water Management District (SFWMD)';
                        link = 'http://www.sfwmd.gov/land';
                        break;
                    case 'SWF':
                        districtName = 'Southwest Florida Water Management District (SWFWMD)';
                        link = 'http://www.swfwmd.state.fl.us/documents/plans/landusemgmt';
                        break;
                    case 'SJR':
                        districtName = 'St. Johns River Water Management District (SJRWMD)';
                        link = 'http://www.sjrwmd.com/landmanagementplans';
                        break;
                    case 'NWF':
                        districtName = 'Northwest Florida Water Management District (NWFWMD)';
                        break;
                    case 'SR':
                        districtName = 'Suwannee River Water Management District (SRWMD)';
                        break;
                    default:
                        districtName = undefined;
                        link = undefined;
                }

                const content = (
                    <React.Fragment>
                        <div className="mb-3">
                            <strong>
                                {atts.LANDCOVER_DESCRIPTION} // {atts.LEVEL2_LANDUSE_DESCRIPTION}
                            </strong>
                        </div>
                        <p className="mb-1">
                            This layer shows wetlands as deterined by {districtName}. Most wetlands are highly regulated by federal, state, and local agencies. Permits are required
                            to impact regulated wetland habitat.
                        </p>
                        <p className="mb-1">
                            Cost: Regulations require that wetlands must be avoided as much as possible. After impacts to wetlands are justified, mitigation to offset the impact
                            such as creating new wetlands on site or purchasing mitigation credits is required at a cost ranging from $50,000-$200,000 per acre (not including
                            permitting costs) depending on habitat quality and type.
                        </p>
                        {link ? <BSLAExternalLinkComponent href={link} /> : null}
                    </React.Fragment>
                );

                ReactDOM.render(content, node);

                return node;
            }
        }
    });
};

export default BSLALandUseWetlandsWMDLayer;
